import React from 'react';
import { Card } from './ui/card';
import { Building2, MapPin, CheckCircle2 } from 'lucide-react';

const HospitalAffiliation = ({ hospital }) => {
  return (
    <section id="hospital" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Hospital Affiliation
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Currently serving at a premier cancer care institution
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Card className="overflow-hidden border-slate-200 shadow-xl">
            <div className="bg-gradient-to-r from-teal-600 to-teal-700 p-8 sm:p-10 text-white">
              <div className="flex items-start space-x-4 mb-4">
                <div className="p-3 bg-white/20 rounded-lg backdrop-blur-sm">
                  <Building2 className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-2xl sm:text-3xl font-bold mb-2">
                    {hospital?.name}
                  </h3>
                  <div className="flex items-center space-x-2 text-teal-100">
                    <MapPin className="w-4 h-4" />
                    <span className="text-lg">{hospital?.location}</span>
                  </div>
                </div>
              </div>
              <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg text-white font-semibold">
                {hospital?.role}
              </div>
            </div>
            
            <div className="p-8 sm:p-10 bg-white">
              <p className="text-lg text-slate-700 leading-relaxed mb-8">
                {hospital?.description}
              </p>
              
              <h4 className="text-xl font-bold text-slate-900 mb-6">World-Class Facilities</h4>
              <div className="grid sm:grid-cols-2 gap-4">
                {hospital?.facilities?.map((facility, idx) => (
                  <div key={idx} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-teal-50 transition-colors">
                    <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0" />
                    <span className="text-slate-700 font-medium">{facility}</span>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default HospitalAffiliation;